<div class="is-maes-header-sticky">
  <div fxFlex="30%" class="container-is-maes-header">
    {{ "diogelwch.beth" | translate }}
  </div>
  <div fxFlex="50%" class="container-is-maes-header-cod-marcio">
    <div class="label-opsiynau">
      <span class="label-opsiwn">
        <fa-icon icon="times-circle"></fa-icon>
      </span>
      <span class="label-opsiwn">
        <strong>M</strong>
      </span>
      <span class="label-opsiwn">
        <strong>N/A</strong>
      </span>
      <span class="label-opsiwn">
        <strong>NC</strong>
      </span>
      <span class="label-opsiwn">
        <fa-icon icon="check-circle"></fa-icon>
      </span>
    </div>
  </div>
  <div fxFlex="20%" class="container-is-maes-header-rhi-im">
    <span class="label-opsiwn">
      {{ "diogelwch.rhifim" | translate }}
    </span>
  </div>
</div>

@for (field of field.fieldGroup; track field; let i = $index) {
  <div>
    <mat-divider></mat-divider>
    <div fxFlex="30%" class="container-is-maes-teitl">
      {{ model[i].teitl | translate }}
    </div>
    <div fxFlex="50%" class="container-is-maes-cod-marcio">
      <formly-group [field]="field"></formly-group>
    </div>
    <div fxFlex="20%" class="container-is-maes-rhif-im">
      @for (rhifIm of model[i].isMaesDiogelwchRhifauLlawlyfrArolygu; track rhifIm; let last = $last) {
        <span> {{ rhifIm.cod }}{{ last ? "" : " /&nbsp;" }} </span>
      }
    </div>
  </div>
}
